// const  common_api  = '/stage-api'
const  common_api  = '/platform/prod-api'

export default common_api


// WEBPACK FOOTER //
// ./src/api/config.js